
import React from "react";
import CloudLoginLink from "@/components/auth/CloudLoginLink";
import { PulseSearchWord } from "@/components/ui/animations/PulseSearchWord";
import HoverGlowText from "@/components/ui/animations/HoverGlowText";
import { LIST_NAMES, type MovieListName } from "@/hooks/search/types/listConstants";

interface EmptyStateMessagesProps {
  tabType: MovieListName;
  isAuthenticated: boolean;
  onSearchFocus: () => void;
}

/**
 * Component that provides appropriate empty state messages based on authentication status and tab type
 */
const EmptyStateMessages: React.FC<EmptyStateMessagesProps> = ({ 
  tabType, 
  isAuthenticated, 
  onSearchFocus 
}) => {
  if (!isAuthenticated) {
    return <CloudLoginLink />;
  }
  
  // Common text size classes for all message types
  const textSizeClasses = "text-sm md:text-base";
  
  // Default empty messages for authenticated users
  switch(tabType) {
    case LIST_NAMES.FAVORITES:
      return (
        <div className={`flex items-baseline flex-wrap ${textSizeClasses}`}>
          <HoverGlowText variant="muted" className="inline">
            Start your journey with a
          </HoverGlowText>
          <PulseSearchWord onClick={onSearchFocus} className="ml-1 inline" />
        </div>
      );
    case LIST_NAMES.UNSEEN_GEMS:
      return (
        <div className={`flex items-baseline flex-wrap ${textSizeClasses}`}>
          <HoverGlowText variant="muted" className="inline">
            Something brilliant shimmers on the horizon
          </HoverGlowText>
        </div>
      );
    case LIST_NAMES.WATCHLIST:
      return (
        <div className={`flex items-baseline flex-wrap ${textSizeClasses}`}>
          <HoverGlowText variant="muted" className="inline">
            The thrill of not yet knowing
          </HoverGlowText>
        </div>
      );
    default:
      return (
        <div className={textSizeClasses}>
          No movies to display.
        </div>
      );
  }
};

export default EmptyStateMessages;
